import request from '../utils/request';

// 创建售后类型
export const createAfterSalesType = (data) => {
  return request({
    url: '/after-sales-type/create',
    method: 'post',
    data
  });
};

// 更新售后类型
export const updateAfterSalesType = (data) => {
  return request({
    url: '/after-sales-type/update',
    method: 'put',
    data
  });
};

// 删除售后类型
export const deleteAfterSalesType = (id) => {
  return request({
    url: `/after-sales-type/delete/${id}`,
    method: 'delete'
  });
};

// 分页查询售后类型
export const pageAfterSalesTypes = (params) => {
  return request({
    url: '/after-sales-type/page',
    method: 'post',
    data:params
  });
};
